import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import "./PackagingHistory.css";

const API_BASE = import.meta.env.VITE_API_BASE_URL || "https://techiohisab.com/api";
const PACKAGING_API = `${API_BASE}/packaging`;

const formatInr = (value) =>
  new Intl.NumberFormat("en-IN", {
    style: "currency",
    currency: "INR",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(Number(value || 0));

const formatPackagingDateTime = (value) => {
  if (!value) return "-";
  const parsed = new Date(value);
  if (Number.isNaN(parsed.getTime())) return "-";
  return parsed.toLocaleString("en-IN");
};

export default function PackagingHistory() {
  const navigate = useNavigate();
  const [entries, setEntries] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchEntries = async () => {
    try {
      setLoading(true);
      const res = await axios.get(PACKAGING_API);
      setEntries(Array.isArray(res.data) ? res.data : []);
    } catch (error) {
      console.error("Packaging history error:", error);
      setEntries([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchEntries();
  }, []);

  return (
    <div className="packaging-history-page">
      <div className="packaging-history-header">
        <button
          id="packaging-history-back-btn"
          type="button"
          className="packaging-history-back-btn"
          onClick={() => navigate("/packaging")}
        >
          Back
        </button>
        <h2>Packaging History</h2>
        <div className="packaging-history-subtitle">(Saved Packaging Entries)</div>
      </div>

      <table className="packaging-history-table">
        <thead>
          <tr>
            <th>Date</th>
            <th>Material</th>
            <th>Size</th>
            <th>Quantity</th>
            <th>Cost/Unit</th>
            <th>Total Cost</th>
            <th>Supplier</th>
            <th>Account</th>
            <th>Status</th>
          </tr>
        </thead>
        <tbody>
          {loading && (
            <tr>
              <td colSpan="9" className="packaging-history-empty">
                Loading packaging history...
              </td>
            </tr>
          )}

          {!loading && entries.length === 0 && (
            <tr>
              <td colSpan="9" className="packaging-history-empty">
                No packaging history found
              </td>
            </tr>
          )}

          {!loading &&
            entries.map((entry) => (
              <tr key={entry.id}>
                <td>{formatPackagingDateTime(entry.created_at || entry.entry_date || entry.date)}</td>
                <td>{entry.material || "-"}</td>
                <td>{entry.size_variant || "-"}</td>
                <td>{Number(entry.quantity || 0)}</td>
                <td>{formatInr(entry.cost_per_unit)}</td>
                <td>{formatInr(entry.total_cost)}</td>
                <td>{entry.supplier_name || "-"}</td>
                <td>{entry.account_name || "-"}</td>
                <td>{entry.status || "Added"}</td>
              </tr>
            ))}
        </tbody>
      </table>
    </div>
  );
}
